<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-bookmark-box-multiple</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.attendance') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 15px 0 15px;" /> -->    
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <span style="color:rgba(0, 0, 0, 0.54);">WorkspaceID : </span>
      <v-text-field
        v-model="workspaceID"
        append-icon="mdi-search"
        hideDetails
        single-line
        style="margin-left: 15px;"
        @input="handleChange"
      />
    </v-toolbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      workspaceID: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
      this.workspaceID = this.content.AttendanceWorkspaceID
    },
    methods: {      
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleChange () {
        this.content.AttendanceWorkspaceID = this.workspaceID
        this.handleChangeIsModified()
      },
    }
  }
</script>

<style scoped>
</style>

